import { Injectable } from "@angular/core";

export type AuthMode = "portal" | "external";

@Injectable({ providedIn: "root" })
export class AuthModeService {
  private _mode: AuthMode = "external";

  get mode(): AuthMode {
    return this._mode;
  }

  setMode(value: unknown): void {
    if (value === "portal" || value === "external") {
      this._mode = value;
    }
  }
}
